import { render, staticRenderFns } from "./GroupSideBar.vue?vue&type=template&id=fc7d54ee&scoped=true&"
import script from "./GroupSideBar.vue?vue&type=script&lang=js&"
export * from "./GroupSideBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupSideBar.vue?vue&type=style&index=0&id=fc7d54ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7d54ee",
  null
  
)

export default component.exports